const dayNames = [
  'Sonntag',
  'Montag',
  'Dienstag',
  'Mittwoch',
  'Donnerstag',
  'Freitag',
  'Samstag',
];

const shortNames = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

export const getTimeString = (date, suffix = 'Uhr') => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${suffix}`;
};

export const getDateString = (date) => {
  const weekday = date.getDay();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${dayNames[weekday]}, ${day < 10 ? '0' + day : day}.${
    month < 10 ? '0' + month : month
  }.${year} `;
};

export const getHours = (date) => {
  return date.getHours();
};

export const getHoursString = (date, suffix = 'Uhr') => {
  const hours = date.getHours();
  return `${hours} ${suffix}`;
};

export const getDayNameShort = (date) => {
  return shortNames[date.getDay()];
};

export const getDayName = (date) => {
  return dayNames[date.getDay()];
};
